import styled from 'styled-components';
import "@fontsource/roboto";


export const ImgGrid = styled.div`
padding: 20px auto;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 10px;

  @media screen and (max-width: 726px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const TermsLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
`

export const QuestionsGridLayout = styled.div`
  display: grid;
  letter-spacing: .009em;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;

  @media screen and (max-width: 726px) {
    grid-template-columns: 1fr;
  }
`;

export const ContactPageBody = styled.div`
    position: absolute;
    display: flex;
    height: 100%;
    width: 100%;
    font-family: SF Pro Display,SF Pro Icons,AOS Icons,Helvetica Neue,Helvetica,Arial,sans-serif;
    justify-content: center;
`;

export const ContactPageHeader = styled.div`
position: absolute;
display: block;
height: 400px;
width:100%;
overflow: hidden;
object-fit: cover;

@media only screen and (max-width: 1024px)
{
    min-height: 300px;
    height: 300px;
}
@media only screen and (max-width: 726px)
{
    min-height: 250px;
    height: 200px;
}
`;

export const ContactPageEmail = styled.div`
    position: absolute;
    display: block;
    height: auto;
    width: 80%;
    top:500px;
    text-align: center;
    letter-spacing: .009em;
    font-size: 32px;
    color: #1D1D1F;
    @media screen and (max-width: 1024px) {
    font-size: 24px;
    line-height: 1.16667;
    letter-spacing: .009em;
    top: 400px;
    }
    @media screen and (max-width: 726px) {
        font-size: 24px;
        line-height: 1.16667;
        letter-spacing: .009em;
        top: 320px;
        }
`;

export const Footer = styled.div`
background: #f2f2f2;
height: 100px;
left:0;
right:0;
bottom:0;
flex-direction: column;
padding:30px 0 0 0px;
width:100%;
top:900px;
position: absolute;
display: list;
align-items: top;
font-family: SF Pro Display,SF Pro Icons,AOS Icons,Helvetica Neue,Helvetica,Arial,sans-serif;

@media screen and (max-width: 1024px) {
    line-height: 1.16667;
    letter-spacing: .009em;
    top:800px;
    height: 90px;
}
@media screen and (max-width: 726px) {
    line-height: 1.16667;
    letter-spacing: .009em;
    top:800px;
    height: 90px;
}
`;

export const FooterWrapper = styled.div`
width: 100%;
background-color: #f2f2f2;
`;


export const FooterSocials = styled.div`
height:auto;
width:100%;
text-align: center;
position: absolute;
display: block;
justify-content: center;
font-size: 18px;

@media screen and (max-width: 726px) {
    line-height: 1.16667;
    letter-spacing: .009em;
    font-size: 18px;
    }
`;